import { callApi } from 'utils/api';

export function f2fStatusFetch() {
  return callApi('/f2f');
}

export function f2fLanguagesFetch() {
  return callApi('/f2f/languages');
}

export function f2fLocationsFetch() {
  return callApi('/f2f/locations');
}

export function f2fScoolsFetch() {
  return callApi('/f2f/schools');
}

export function f2fReferralCreate(data) {
  return callApi('/f2f', {
    method: 'POST',
    body: {
      ...data
    }
  });
}

export function f2fFieldValidate(field, value) {
  return callApi(`/f2f/check-${field}`, {
    query: {
      [field]: value
    }
  });
}



/** WEBPACK FOOTER **
 ** ./src/members/state/f2f/api.js
 **/